import React, { useState } from 'react';
import { ExternalLink, Filter } from 'lucide-react';
export function Portfolio() {
  const [activeFilter, setActiveFilter] = useState('all');
  const categories = [{
    id: 'all',
    label: 'All Projects'
  }, {
    id: 'websites',
    label: 'Websites'
  }, {
    id: 'portals',
    label: 'Web Portals'
  }, {
    id: 'mobile',
    label: 'Mobile Apps'
  }, {
    id: 'government',
    label: 'Government'
  }, {
    id: 'writing',
    label: 'Business Writing'
  }];
  const projects = [{
    id: 1,
    title: 'Edo State Government Website',
    category: 'government',
    description: 'Complete redesign and modernization of the main state government website',
    image: '🏛️',
    tags: ['Web Design', 'CMS', 'Government']
  }, {
    id: 2,
    title: 'Presidential Amnesty Program Portal',
    category: 'portals',
    description: 'Comprehensive portal for program management and beneficiary tracking',
    image: '🎓',
    tags: ['Portal', 'Government', 'Database']
  }, {
    id: 3,
    title: 'Nigerian Investment Promotion Commission',
    category: 'websites',
    description: 'Modern website showcasing investment opportunities in Nigeria',
    image: '💼',
    tags: ['Corporate', 'Investment', 'Multilingual']
  }, {
    id: 4,
    title: 'Myma Foods E-commerce Platform',
    category: 'websites',
    description: 'Full-featured online store with inventory management and delivery tracking',
    image: '🛒',
    tags: ['E-commerce', 'Payment Integration', 'Logistics']
  }, {
    id: 5,
    title: 'AutoByte Fleet Management App',
    category: 'mobile',
    description: 'Mobile application for vehicle tracking and maintenance scheduling',
    image: '🚗',
    tags: ['Mobile', 'IoT', 'Real-time Tracking']
  }, {
    id: 6,
    title: 'Dmayo Photography Portfolio',
    category: 'websites',
    description: 'Stunning portfolio website with gallery and booking system',
    image: '📸',
    tags: ['Portfolio', 'Gallery', 'Booking']
  }, {
    id: 7,
    title: 'Edo State Tax Portal',
    category: 'portals',
    description: 'Online tax payment and filing system for state residents and businesses',
    image: '💳',
    tags: ['Portal', 'Payment', 'Government']
  }, {
    id: 8,
    title: 'Healthcare Management System',
    category: 'portals',
    description: 'Patient records, appointment scheduling, and telemedicine platform',
    image: '🏥',
    tags: ['Healthcare', 'Portal', 'Database']
  }, {
    id: 9,
    title: 'Business Plan - Tech Startup',
    category: 'writing',
    description: 'Comprehensive business plan securing $500K seed funding',
    image: '📄',
    tags: ['Business Writing', 'Funding', 'Strategy']
  }, {
    id: 10,
    title: 'Grant Proposal - Education NGO',
    category: 'writing',
    description: 'Winning grant proposal for international development organization',
    image: '✍️',
    tags: ['Grant Writing', 'NGO', 'Education']
  }, {
    id: 11,
    title: 'Company Profile - Manufacturing',
    category: 'writing',
    description: 'Professional company profile for B2B marketing and partnerships',
    image: '🏭',
    tags: ['Corporate Writing', 'B2B', 'Marketing']
  }, {
    id: 12,
    title: 'Education Portal',
    category: 'portals',
    description: 'Learning management system for schools and training institutions',
    image: '📚',
    tags: ['Education', 'LMS', 'Portal']
  }];
  const filteredProjects = activeFilter === 'all' ? projects : projects.filter(p => p.category === activeFilter);
  return <div className="min-h-screen bg-white pt-20" data-id="element-627">
      {/* Hero Section with Beautiful Header Image */}
      <section className="relative py-20 sm:py-32 bg-gradient-to-br from-slate-900 to-blue-900 text-white overflow-hidden" data-id="element-628">
        <div className="absolute inset-0 opacity-30" data-id="element-629">
          <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?q=80&w=2000&auto=format&fit=crop" alt="Black professionals reviewing digital portfolio and project showcase" className="w-full h-full object-cover" data-id="element-630" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/80 to-blue-900/80" data-id="element-631" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 text-center" data-id="element-632">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-black mb-6" data-id="element-633">
            Our Portfolio
          </h1>
          <p className="text-lg sm:text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed" data-id="element-634">
            Explore our diverse range of successful projects across web
            development, mobile apps, government digitization, and professional
            business writing
          </p>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-12 bg-slate-50 sticky top-20 z-40 border-b border-slate-200" data-id="element-635">
        <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-636">
          <div className="flex items-center gap-4 overflow-x-auto pb-2" data-id="element-637">
            <Filter className="w-5 h-5 text-slate-600 flex-shrink-0" data-id="element-638" />
            {categories.map(category => <button key={category.id} onClick={() => setActiveFilter(category.id)} className={`px-6 py-2.5 rounded-lg font-bold whitespace-nowrap transition-all duration-300 ${activeFilter === category.id ? 'bg-blue-600 text-white shadow-lg' : 'bg-white text-slate-700 hover:bg-slate-100'}`} data-id="element-639">
                {category.label}
              </button>)}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-12 sm:py-20" data-id="element-640">
        <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-641">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-642">
            {filteredProjects.map(project => <ProjectCard key={project.id} project={project} data-id="element-643" />)}
          </div>

          {filteredProjects.length === 0 && <div className="text-center py-20" data-id="element-644">
              <div className="text-6xl mb-4" data-id="element-645">🔍</div>
              <div className="text-xl text-slate-600" data-id="element-646">
                No projects found in this category
              </div>
            </div>}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-20 bg-slate-50" data-id="element-647">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-648">
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mb-6" data-id="element-649">
            Let's Build Something Amazing Together
          </h2>
          <p className="text-lg sm:text-xl text-slate-600 mb-10" data-id="element-650">
            Ready to start your project? Get in touch with our team today
          </p>
          <a href="/contact" className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-bold text-base sm:text-lg transition-all duration-300 hover:scale-105" data-id="element-651">
            Start Your Project
            <ExternalLink className="w-5 h-5" data-id="element-652" />
          </a>
        </div>
      </section>
    </div>;
}
function ProjectCard({
  project
}: {
  project: any;
}) {
  return <div className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden hover:-translate-y-2" data-id="element-653">
      <div className="aspect-video bg-gradient-to-br from-blue-100 to-cyan-100 flex items-center justify-center text-8xl group-hover:scale-110 transition-transform duration-300" data-id="element-654">
        {project.image}
      </div>
      <div className="p-6" data-id="element-655">
        <h3 className="text-xl font-black text-slate-900 mb-2 group-hover:text-blue-600 transition-colors" data-id="element-656">
          {project.title}
        </h3>
        <p className="text-slate-600 mb-4 leading-relaxed" data-id="element-657">
          {project.description}
        </p>
        <div className="flex flex-wrap gap-2" data-id="element-658">
          {project.tags.map((tag: string, index: number) => <span key={index} className="px-3 py-1 bg-slate-100 text-slate-700 text-xs font-bold rounded-full" data-id="element-659">
              {tag}
            </span>)}
        </div>
      </div>
    </div>;
}